import { render, staticRenderFns } from "./ApplicantsKorolev.vue?vue&type=template&id=68336b18&"
import script from "./ApplicantsKorolev.vue?vue&type=script&lang=js&"
export * from "./ApplicantsKorolev.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantsKorolev.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports